<template>
  <button type="button" class="btn btn-primary btn-sm rounded-pill position-relative" data-placement="bottom" data-toggle="tooltip"
          data-coreui-toggle="offcanvas" data-coreui-target="#notificationTalkArea" aria-controls="notificationTalkArea" id="notification-talk-button">
    <i class="cil-chat-bubble"></i>
    <span v-if="existsUnreadTalk" class="position-absolute top-5 start-100 translate-middle p-1 bg-danger rounded-circle"></span>
  </button>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: "NotificationTalkButton",
  computed: {
    ...mapGetters('talk_notifieds', [
      'existsUnreadTalk'
    ]),
  },
}
</script>
